import React, {
  useState, useRef, useCallback, RefObject, ReactElement,
} from 'react';
import Menu from '../menu/menu.component';
import MenuItem from '../menu-item/menu-item.component';
import CheckedIcon from '../../icons/checked-icon';
import ArrowRightSmallIcon from '../../icons/arrow-right-small-icon';
import useStylesMenuItemNested from './menu-item-nested.styles';

const MenuItemNested: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const ANCHOR_TOP: MenuAnchor = 'top';
  const ANCHOR_RIGHT: MenuAnchor = 'right';
  const TRANSFORM_TOP: MenuTransform = 'top';
  const TRANSFORM_LEFT: MenuTransform = 'left';

  const {
    isActive,
    isParentMenuOpen,
    label,
    value,
    onClick,
    onContextMenu,
    children,
  } = props;

  const { classes } = useStylesMenuItemNested();
  const containerRef: RefObject<HTMLDivElement> | null = useRef(null);

  const [menuAnchor, setMenuAnchor]: [HTMLElement | null, Function] = useState(null);

  const onMouseEnter: MouseEventHandlerFunction = useCallback((event: React.MouseEvent<Element, MouseEvent>): void => {
    setMenuAnchor(event.currentTarget);
  }, []);

  const onMouseLeave: MouseEventHandlerFunction = useCallback((): void => {
    setMenuAnchor(null);
  }, []);

  const onClose: CloseActionMenuHandlerFunction = useCallback((): void => {
    setMenuAnchor(null);
  }, []);

  return (
    <div ref={containerRef} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <MenuItem
        isActive={isActive}
        value={value}
        className={classes.menuItem}
        onClick={onClick}
        onContextMenu={onContextMenu}
      >
        {label}
        <ArrowRightSmallIcon />
        {
          isActive && (
            <CheckedIcon />
          )
        }
      </MenuItem>
      <Menu
        withNoFocus
        withNoPointerEvents
        isOpen={isParentMenuOpen}
        menuAnchor={menuAnchor}
        anchorOrigin={{
          vertical: ANCHOR_TOP,
          horizontal: ANCHOR_RIGHT,
        }}
        transformOrigin={{
          vertical: TRANSFORM_TOP,
          horizontal: TRANSFORM_LEFT,
        }}
        onClose={onClose}
        onContextMenu={onContextMenu}
      >
        {children}
      </Menu>
    </div>
  );
});

export default MenuItemNested;
